<template>
<div class="log" v-if="isLog">
  <div class="__hand" @click="toggleZl"></div>
  <div class="__zlLog" v-show="show">
    <float
      class="log_btn"
      :itemWidth="50"
      :itemHeight="50"
      :coefficientHeight="0.8"
      @onClick="handBtn"
    >
      <van-icon name="browsing-history" size="50" />
    </float>

    <van-popup v-model="isLogShow" position="bottom" :style="{ height: '80%' }" >
      <div class="log_wrap">
        <div class="list font12">
          <div class="padding5 item"
            :class="item.type || 'info'"
            v-for="(item, i) in list" :key="i">
            <div class="flexSb alignFs">
              <p class="consoleName">{{item.consoleName}}</p>
              <p class="flexS marginL5  colorb flexSbCe">
                <span class="marginR5">{{item.time}}</span>
                <span class="paddingLR8 " v-if="item.showType === 'str'" @click="item.showType = 'obj'">{ }</span>
                <span class="paddingLR8 fontW color6" v-else @click="item.showType = 'str'">{ }</span>
                <span class="icon_copy flexC" v-copy="item.valueStr">
                  <svg viewBox="0 0 16 16"><path fill-rule="evenodd" d="M5.75 1a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75v-3a.75.75 0 00-.75-.75h-4.5zm.75 3V2.5h3V4h-3zm-2.874-.467a.75.75 0 00-.752-1.298A1.75 1.75 0 002 3.75v9.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0014 13.25v-9.5a1.75 1.75 0 00-.874-1.515.75.75 0 10-.752 1.298.25.25 0 01.126.217v9.5a.25.25 0 01-.25.25h-8.5a.25.25 0 01-.25-.25v-9.5a.25.25 0 01.126-.217z"></path><path fill-rule="evenodd" d="M5.75 1a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75v-3a.75.75 0 00-.75-.75h-4.5zm.75 3V2.5h3V4h-3zm-2.874-.467a.75.75 0 00-.752-1.298A1.75 1.75 0 002 3.75v9.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0014 13.25v-9.5a1.75 1.75 0 00-.874-1.515.75.75 0 10-.752 1.298.25.25 0 01.126.217v9.5a.25.25 0 01-.25.25h-8.5a.25.25 0 01-.25-.25v-9.5a.25.25 0 01.126-.217z"></path></svg>
                </span>
              </p>
            </div>

            <p class="marginT2" v-if="item.showType === 'str'">{{item.valueStr}}</p>
            <p class="marginT2" v-else>
              <pre v-text="item.value"></pre>
            </p>
          </div>

          <div class="bot flexSbCe">
            <p @click="clear">clear</p>
            <p @click="isLogShow = false">hide</p>
            <p @click="handleTest">test</p>
            <p @click="toggleVc">vconsole</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</div>
</template>

<script>
import float from '@/components/float.vue'

export default {
  name: 'LOG',
  components: { float },
  data () {
    return {
      isLog: false,
      show: false,
      isLogShow: false,
      count: 0,
      lastClickTime: 0,
      list: [],
      onceTimer: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.init()
      }, 3000)
    })
  },
  methods: {
    handBtn () {
      if (this.isLogShow) {
        this.isLogShow = false
      } else {
        this.list = this.$local.log().map(item => {
          const { value } = item
          const str = typeof value !== 'string' ? JSON.stringify(value) : value
          if (str.length > 2000) {
            item.valueStr = str.slice(0, 1000) + '..................' + str.slice(-1000)
          } else {
            item.valueStr = str
          }
          item.showType = 'str'
          return item
        })
        this.isLogShow = true
      }
    },
    clear () {
      this.$local.logClear()
      this.list = []
      this.isLogShow = false
    },
    handleTest () {
      this.$router.push('/test')
      this.isLogShow = false
    },

    init () {
      const { isUserWhite, phoneNo } = this.$local.get('userData') || {}
      this.show = phoneNo === (parseInt('4a534e410', 16) + '')
      this.isLog = (isUserWhite === '1') || this.show || !this.$local.isLogined()
      if (this.show) {
        // process.env.NODE_ENV !== 'production'
        this.toggleVc()
      }
    },
    toggleZl () {
      if (!this.isLog) return
      const vconDom = document.getElementById('__vconsole')
      if (this.hasClass(vconDom, 'show')) {
        this.removeClass(vconDom, 'show')
      }
      if (this.show) {
        this.show = false
        return
      }

      const nowTime = new Date().getTime()
      if (!this.onceTimer) {
        this.onceTimer = setTimeout(() => {
          this.lastClickTime = 0
          clearTimeout(this.onceTimer)
          this.onceTimer = null
        }, 3000)
      }
      if (!this.lastClickTime) {
        this.lastClickTime = nowTime
      }
      if (nowTime - this.lastClickTime < 3000) {
        this.count++
      } else {
        this.count = 0
      }
      this.lastClickTime = nowTime
      if (this.count >= 10) {
        this.count = 0
        this.show = true
      }
    },
    toggleVc () {
      let vconDom = document.getElementById('__vconsole')
      vconDom && this.toggleClass(vconDom, 'show')
    },
    hasClass (obj, cls) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
    },
    addClass (obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += ' ' + cls
    },
    toggleClass (obj, cls) {
      if (this.hasClass(obj, cls)) {
        this.removeClass(obj, cls)
      } else {
        this.addClass(obj, cls)
      }
    },
    removeClass (obj, cls) {
      if (this.hasClass(obj, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        obj.className = obj.className.replace(reg, ' ')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.log {
  word-break: break-all;
  .__hand {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 99999;
    background-color: rgba(55, 55, 55, 0.01);
    width: 50px;
    height: 50px;
  }

  .log_btn {
    z-index: 99;
    .van-icon {
      color: rgba(155, 155, 155, 0.1);
    }
  }
  .van-popup {
    z-index: 999999 !important;
    .log_wrap {
      height: 100%;
      overflow: auto;
    }
    .list {
      padding-bottom: 70px;
      .item {
        border-bottom: 1px solid #ddd;
        .icon_copy {
          width: 16px;
          fill: #aaa;
          padding: 1px 8px;
        }
      }
      .info {
        color: #666;
      }
      .primary {
        color: blue;
      }
      .warning {
        color: orange;
      }
      .danger {
        color: red;
      }
    }
    .bot {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #eee;
      height: 40px;
      line-height: 40px;
      p {
        text-align: center;
        &:nth-child(1) {
          color: #999;
          flex-basis: 80px;
          border-right: 1px solid #ddd;
        }
        &:nth-child(2) {
          color: #999;
          flex-grow: 1;
          border-right: 1px solid #ddd;
        }
        &:nth-child(3) {
          color: #999;
          flex-basis: 80px;
          border-right: 1px solid #ddd;
        }
        &:nth-child(4) {
          color: #999;
          flex-basis: 80px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zl-log.vue